var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"appcontactsupport"}},[_c('div',{staticClass:"pa-2"},[_c('v-row',{attrs:{"justify":"space-between"}},[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('ContactFormSupport')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }